var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWheelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12165_12966",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.681641 0.203125H10.915V12.7983H0.681641V0.203125Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12165_12966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.77631 1.90521V2.58601H6.81881V1.90521H4.77631ZM8.18047 10.4155V9.73467C8.18047 9.17067 8.63764 8.71346 9.20169 8.71346H9.88249C10.4465 8.71346 10.9037 9.17069 10.9037 9.73467V11.7772C10.9037 12.3412 10.4465 12.7984 9.88249 12.7984H9.20169C8.63762 12.7984 8.18047 12.3412 8.18047 11.7772V11.0963H7.49961C7.49961 11.4723 7.19479 11.7772 6.81881 11.7772H4.77631C4.40032 11.7772 4.09551 11.4724 4.09551 11.0963H3.41464V11.7772C3.41464 12.3412 2.95741 12.7984 2.39342 12.7984H1.71262C1.14856 12.7984 0.691406 12.3412 0.691406 11.7772V9.73467C0.691406 9.17067 1.14857 8.71346 1.71262 8.71346H2.39342C2.95742 8.71346 3.41464 9.17069 3.41464 9.73467V10.4155H4.09551C4.09551 10.0395 4.40032 9.73467 4.77631 9.73467H5.45717V3.26684H4.77631C4.40032 3.26684 4.09551 2.96202 4.09551 2.58597H3.41464V3.26684C3.41464 3.83084 2.95741 4.28806 2.39342 4.28806H1.71262C1.14856 4.28806 0.691406 3.83082 0.691406 3.26684V1.22434C0.691406 0.660342 1.14857 0.203125 1.71262 0.203125H2.39342C2.95742 0.203125 3.41464 0.660358 3.41464 1.22434V1.90521H4.09551C4.09551 1.52917 4.40032 1.22434 4.77631 1.22434H6.81881C7.19479 1.22434 7.49961 1.52916 7.49961 1.90521H8.18047V1.22434C8.18047 0.660342 8.63764 0.203125 9.20169 0.203125H9.88249C10.4465 0.203125 10.9037 0.660358 10.9037 1.22434V3.26684C10.9037 3.83084 10.4465 4.28806 9.88249 4.28806H9.20169C8.63762 4.28806 8.18047 3.83082 8.18047 3.26684V2.58597H7.49961C7.49961 2.96201 7.19479 3.26684 6.81881 3.26684H6.13794V9.73467H6.81881C7.19479 9.73467 7.49961 10.0395 7.49961 10.4155H8.18047ZM4.77631 10.4155V11.0963H6.81881V10.4155H4.77631Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelIcon);
export default __webpack_public_path__ + "static/media/Wheel-Icon.2e6ef2e1d8235eb6c728d72da740868b.svg";
export { ForwardRef as ReactComponent };